import { Scale } from "../../../utils/Scale"

export class CravPos {

    static titleY = () => Scale.height() * 0.04

    static scientistX = () => Scale.width() * -0.1
    static scientistY = () => Scale.height() * 0.05

    static chairX = () => Scale.width() * 0.42
    static chairY = () => Scale.height() * 0.4

    static chairArmsX = () => Scale.width() * 0.41
    static chairArmsY = () => Scale.height() * 0.77

    static kidX = () => Scale.width() * 0.51
    static kidY = () => Scale.height() * 0.32

    static cigX = () => Scale.width() * 0.555
    static cigY = () => Scale.height() * 0.43

    static noCigX = () => Scale.width() * 0.53
    static noCigY = () => Scale.height() * 0.54

    static hatX = () => Scale.width() * 0.48
    static hatY = () => Scale.height() * 0.12

    static nicMeterX = () => Scale.width() * 0.25
    static nicMeterY = () => Scale.height() * 0.16

    static nicBarX = () => Scale.width() * 0.3
    static nicBarY = () => Scale.height() * 0.26

    static cravBarX = () => Scale.width() * 0.95
    static cravBarY = () => Scale.height() * 0.3
}
